function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("style", null, ".forms-gutenberg_svg__st5{opacity:.1}.forms-gutenberg_svg__st6{opacity:.16}.forms-gutenberg_svg__st7{opacity:.6}.forms-gutenberg_svg__st8{fill:#fff}.forms-gutenberg_svg__st9{opacity:.3}");

var _ref2 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "forms-gutenberg_svg__SVGID_1_",
  gradientUnits: "userSpaceOnUse",
  x1: 23.101,
  y1: 4.596,
  x2: 17.855,
  y2: 19.01,
  gradientTransform: "matrix(1 0 0 -1 0 33)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#4facfe"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00f2fe"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M29 13.1l-1-2.8-5.2 1.9c0 .1.1.3.1.4.1.2.1.5.1.7 0 .1 0 .3.1.4v.8c0 .5.1 1 0 1.6v1c-.1.5-.1 1-.3 1.6h.1c-.1.5-.2 1-.5 1.4-.1.4-.3.8-.4 1.2-.2.4-.3.7-.5 1.1-.1.2-.2.4-.3.5-.1.2-.2.3-.3.5-.2.4-.5.7-.7 1-.1.2-.3.4-.4.5-.1.1-.2.3-.3.4-.1.1-.2.3-.3.4l-.9.9-.4.4c-.3.2-.6.5-.9.7-.1.1-.2.2-.3.2-.2.2-.4.3-.7.5-.1.1-.2.1-.2.2-.2.1-.3.2-.5.3-.2.1-.3.2-.5.3l-.6.3c-.2.1-.3.2-.5.2-.1 0-.1.1-.2.1 0 0-.1 0-.1.1-.1 0-.2.1-.3.1-.2.1-.5.2-.7.3 1.8.3 3.7.4 5.5 0 1.8-.3 3.6-1 5.2-2 2.2-1.3 3.9-3.2 5.1-5.3 1.2-2.1 1.7-4.5 1.5-6.8-.1-1.2-.3-2.1-.7-3.1z",
  fill: "url(#forms-gutenberg_svg__SVGID_1_)"
});

var _ref4 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "forms-gutenberg_svg__SVGID_2_",
  gradientUnits: "userSpaceOnUse",
  x1: 20.054,
  y1: 13.455,
  x2: 18.011,
  y2: 19.068,
  gradientTransform: "matrix(1 0 0 -1 0 33)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#00c6fb"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#005bea"
}));

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M22.8 12.2l-6.4 2.3c-.4.1-.8.4-1.1.6-.3.3-.6.6-.8 1-.2.4-.3.8-.4 1.2 0 .4 0 .8.2 1.2.1.4.4.7.6 1 .3.3.6.5 1 .7.4.2.8.2 1.3.2.4 0 .9-.1 1.3-.2l4.4-1.6c.5-2.2.4-4.4-.1-6.4z",
  fill: "url(#forms-gutenberg_svg__SVGID_2_)"
});

var _ref6 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "forms-gutenberg_svg__SVGID_3_",
  gradientUnits: "userSpaceOnUse",
  x1: 15.53,
  y1: 4.084,
  x2: 8.873,
  y2: 22.373,
  gradientTransform: "matrix(1 0 0 -1 0 33)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#89f7fe"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#66a6ff"
}));

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M22.5 19.9c-.4.9-1 1.7-1.7 2.4s-1.6 1.2-2.6 1.6c-.4.2-.9.3-1.4.4-.5.1-.9.1-1.4.1-1.4 0-2.7-.4-3.8-1.1-.2-.1-.4-.2-.7-.3-2-1-3.7-2.5-4.9-4.3-1.2-1.8-1.8-3.9-1.9-6v-.2c-1.8 2.9-2.3 6.2-1.5 9.2s2.9 5.6 5.8 7.2c1.2.6 2.5 1.1 3.8 1.3 3.2-1.2 6-3.2 7.9-5.8 1.1-1.5 1.9-2.9 2.4-4.5z",
  fill: "url(#forms-gutenberg_svg__SVGID_3_)"
});

var _ref8 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "forms-gutenberg_svg__SVGID_4_",
  gradientUnits: "userSpaceOnUse",
  x1: 19.95,
  y1: 23.365,
  x2: 17.904,
  y2: 28.987,
  gradientTransform: "matrix(1 0 0 -1 0 33)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#4facfe"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00f2fe"
}));

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M24.5 1.6l-5.9 2.1c0 .1-.1.2-.1.3-.1.3-.2.5-.2.8-.2.6-.5 1.3-.8 1.9-.1.1-.1.2-.2.4v.1c-.1.2-.2.3-.3.5-.1.2-.2.3-.3.5-.1.1-.2.3-.3.4-.1.1-.1.2-.2.3l-.2.2c-.1.1-.2.2-.2.3l-.1.1c-.1.1-.2.3-.3.4v.1c-.1.1-.2.3-.4.4-.1.1-.2.3-.3.4 0 .1-.1.1-.1.1l-.3.3-.4.4-.3.3c.1-.1.3-.1.4-.2l6.4-2.3 1.2-.6c1.3-.8 2.3-1.9 2.9-3.3.4-1.2.4-2.6 0-3.9z",
  fill: "url(#forms-gutenberg_svg__SVGID_4_)"
});

var _ref10 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "forms-gutenberg_svg__SVGID_5_",
  gradientUnits: "userSpaceOnUse",
  x1: 15.998,
  y1: 11.362,
  x2: 10.556,
  y2: 26.312,
  gradientTransform: "matrix(1 0 0 -1 0 33)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#00c6fb"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#005bea"
}));

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M18.6 3.8l-6.8 2.5c-3 1.1-5.6 3.1-7.3 5.7-.1.1-.2.3-.3.4v1.1c0 .2 0 .4.1.6 0 .1 0 .2.1.3 0 .1.1.3.1.4 0 .1.1.2.1.3v.2l.3.9c0 .1.1.1.1.2s0 .1.1.2v.1s0 .1.1.1c0 .1.1.2.2.4 0 0 0 .1.1.1.1.2.1.3.2.5.1.1.1.2.2.3 0 .1.1.1.1.2.2.3.3.5.5.8.1.1.1.2.2.2.3.4.6.8 1 1.2l.3.3c.2.2.5.4.7.6.1.1.2.2.3.2.3.2.6.5.9.7.2.1.3.2.5.3.2.1.3.2.5.3 0 0 .1 0 .1.1.2.1.3.2.5.2-1.1-.7-1.9-1.7-2.4-2.9-.1-.8-.2-1.6-.1-2.5 0-.8.3-1.7.7-2.5.8-1.4 2.1-2.6 3.7-3.3l.3-.3.4-.4.3-.3.1-.1c.1-.1.2-.2.3-.4l.4-.4V10c.1-.1.2-.3.3-.4l.1-.1c.1-.1.2-.2.2-.3L16 9c.1-.1.1-.2.2-.3.1-.1.2-.3.3-.4.1-.2.2-.3.3-.5.1-.2.2-.3.3-.5v-.1c.1-.1.1-.2.2-.4.3-.6.6-1.2.8-1.9.1-.3.2-.5.2-.8.2-.1.3-.2.3-.3z",
  fill: "url(#forms-gutenberg_svg__SVGID_5_)"
});

var _ref12 = /*#__PURE__*/React.createElement("g", {
  className: "forms-gutenberg_svg__st5"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.2 23.8c-.4.2-.9.3-1.4.4-2 1.7-4.7 3.2-8.4 4.6 1.2.6 2.5 1.1 3.8 1.3 3.2-1.2 6-3.2 7.9-5.8 1-1.4 1.8-2.8 2.3-4.4-.4.9-1 1.7-1.7 2.4s-1.6 1.2-2.5 1.5z"
}));

var _ref13 = /*#__PURE__*/React.createElement("g", {
  className: "forms-gutenberg_svg__st6"
}, /*#__PURE__*/React.createElement("path", {
  d: "M22.8 12.2l-.6.2c.2 2.3-.3 4.7-1.4 6.9l2-.7c.6-2.2.5-4.4 0-6.4z"
}));

var _ref14 = /*#__PURE__*/React.createElement("g", {
  className: "forms-gutenberg_svg__st5"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.2 8.9c-1.1.9-2 1.9-2.8 3.1-.1.1-.2.3-.3.4v1.1c0 .2 0 .4.1.6 0 .1 0 .2.1.3 0 .1.1.3.1.4 0 .1.1.2.1.3v.2l.3.9c0 .1.1.1.1.2s0 .1.1.2v.1s0 .1.1.1c0 .1.1.2.2.4 0 0 0 .1.1.1.1.2.1.3.2.5.1.1.1.2.2.3 0 .1.1.1.1.2.2.3.3.5.5.8.1.1.1.2.2.2.3.4.6.8 1 1.2l.3.3c.2.2.5.4.7.6.1.1.2.2.3.2.3.2.6.5.9.7.2.1.3.2.5.3.2.1.3.2.5.3 0 0 .1 0 .1.1.2.1.3.2.5.2-1.1-.7-1.9-1.7-2.4-2.9C7.4 18 6 14.4 6.9 9.1c.3-.1.3-.2.3-.2z"
}));

var _ref15 = /*#__PURE__*/React.createElement("g", {
  className: "forms-gutenberg_svg__st5"
}, /*#__PURE__*/React.createElement("path", {
  d: "M22.5 2.4l-3.9 1.4c0 .1-.1.2-.1.3-.1.3-.2.5-.2.8-.2.6-.5 1.3-.8 1.9-.1.1-.1.2-.2.4v.1c-.1.2-.2.3-.3.5-.1.2-.2.3-.3.5-.1.1-.2.3-.3.4-.1.1-.1.2-.2.3-.1 0-.1 0-.2.1s-.2.2-.2.3l-.1.1c-.1.1-.2.3-.3.4v.1c-.1.1-.2.3-.4.4-.1.1-.2.3-.3.4 0 .1-.1.1-.1.1l-.3.3-.4.4-.3.3c.1-.1.3-.1.4-.2l1.7-.6c2.9-2.4 5.2-5.3 6.8-8.5-.1 0-.1-.1 0-.2z"
}));

var _ref16 = /*#__PURE__*/React.createElement("g", {
  className: "forms-gutenberg_svg__st7"
}, /*#__PURE__*/React.createElement("g", {
  className: "forms-gutenberg_svg__st7"
}, /*#__PURE__*/React.createElement("path", {
  className: "forms-gutenberg_svg__st8",
  d: "M22.1 21.1c-.8 1.9-2 3.6-3.5 5.1-1.5 1.5-3.3 2.7-5.3 3.6.1 0 .2-.1.5-.2.2-.1.4-.1.6-.2.3-.1.5-.2.8-.3.1-.1.3-.1.4-.2.1-.1.3-.2.4-.3l.9-.6c.3-.2.6-.4.9-.7.3-.3.6-.5.9-.8.3-.3.6-.6.8-.9.3-.3.5-.6.7-.9l.6-.9c.2-.3.3-.5.5-.8.1-.3.2-.5.3-.7.1-.2.1-.4.2-.6.2-.4.2-.6.3-.6z"
})));

var _ref17 = /*#__PURE__*/React.createElement("g", {
  className: "forms-gutenberg_svg__st7"
}, /*#__PURE__*/React.createElement("g", {
  className: "forms-gutenberg_svg__st7"
}, /*#__PURE__*/React.createElement("path", {
  className: "forms-gutenberg_svg__st8",
  d: "M18.6 3.8l-.2.4-.5 1-.3.6c-.1.2-.2.5-.4.7L16.3 8c-.3.5-.6 1-.9 1.4-.1.2-.2.4-.4.6-.2.2-.3.4-.4.6-.3.4-.5.7-.7.9-.1.2-.2.3-.2.3 2.4-2.3 4.1-5 4.9-8z"
})));

var _ref18 = /*#__PURE__*/React.createElement("g", {
  className: "forms-gutenberg_svg__st7"
}, /*#__PURE__*/React.createElement("g", {
  className: "forms-gutenberg_svg__st7"
}, /*#__PURE__*/React.createElement("path", {
  className: "forms-gutenberg_svg__st8",
  d: "M4.9 16.2c-.4-1.2-.7-2.4-.7-3.6v.6c0 .5 0 1 .1 1.5.1.7.3 1.4.5 2 .1.3.2.7.4 1 .2.4.4.7.6 1.1.2.3.5.7.7 1 .1.2.3.3.4.5l.4.4c.3.3.6.5.9.7.3.2.5.4.8.6.2.2.5.3.8.4l.6.3c.3.1.5.2.5.2-2.8-1.5-4.9-3.8-6-6.7z"
})));

var _ref19 = /*#__PURE__*/React.createElement("g", {
  className: "forms-gutenberg_svg__st9"
}, /*#__PURE__*/React.createElement("path", {
  d: "M24.5 1.6L11.8 6.2c-3 1.1-5.6 3.1-7.3 5.7.3-.4.6-.7.9-1.1.3-.4.6-.7 1-1 .3-.3.6-.5.9-.8-.1 0 0 0 0 0 .4-.3.8-.6 1.1-.8.4-.3.8-.5 1.2-.7.5-.3 1-.5 1.4-.7.4-.2.9-.3 1.3-.5l1.4-.5 2.7-1 2.7-1c1.1-.4 2.1-.8 3.2-1.2.7-.2 1.3-.5 2-.8l.1.2.1.5.1.5v1l-.1.5-.1.5-.2.5-.2.6-.2.5-.4.4-.3.4-.4.4-.4.4-.4.4-.5.3c1.3-.8 2.3-1.9 2.9-3.3.6-1.3.6-2.7.2-4z"
}));

var _ref20 = /*#__PURE__*/React.createElement("g", {
  className: "forms-gutenberg_svg__st9"
}, /*#__PURE__*/React.createElement("path", {
  d: "M29 13.1l-1-2.8-4.5 1.6c.8-.2 1.5-.5 2.3-.7.7-.2 1.4-.4 2.1-.7l.7 2.2c.1.4.3.8.4 1.2l.3 1.2c.1.4.1.8.1 1.2v1.2c0 .4-.1.8-.1 1.2-.1.4-.1.8-.3 1.2-.1.4-.2.8-.4 1.2-.1.2-.2.4-.2.6l-.3.6-.3.6-.3.6c-.1.2-.2.4-.3.5-.1.2-.2.4-.4.5l-.4.5-.4.4c-.1.2-.3.3-.4.5l-.5.5c-.3.3-.7.6-1 .9-.3.3-.7.5-1.1.8 2.2-1.3 3.9-3.2 5.1-5.3 1.2-2.1 1.7-4.5 1.5-6.8 0-1-.2-1.9-.6-2.9z"
}));

var _ref21 = /*#__PURE__*/React.createElement("text", {
  transform: "translate(300 167.5)",
  fontFamily: "MyriadPro-Regular",
  fontSize: 12
}, "32");

var SvgFormsGutenberg = function SvgFormsGutenberg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "forms-gutenberg_svg__Layer_1",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21);
};

export default SvgFormsGutenberg;